


















    import { Component, Watch, Vue } from "vue-property-decorator";
    import { getCommonInfo } from '@/api/common.js';
    import { EventBus } from '@/utils/eventBus.js';
    import { scrollToTop, checkUserAgent, resize, coordMaps } from '@/utils/index.js';

	@Component
	export default class Header extends Vue {
        private cur: string = '';
        private navList: any = [
            {
                name: '首页',
                url: '/'
            }, {
                name: '关于小盒',
                url: '/about'
            }, {
                name: '小盒产品',
                url: '/product'
            }, {
                name: '小盒新闻',
                url: '/news'
            }, {
                name: '加入小盒',
                url: '/join'
            }
        ];

        @Watch('$route', { immediate: true, deep: true })
        private onUrlChange(val: any, old: any) {
            let coord = 0;

            if (val.query.block) {
                coord = coordMaps[val.query.block];
            }

            scrollToTop(coord);
        }

        private async created() {
            resize();
            checkUserAgent();

            window.addEventListener('resize', () => {
                checkUserAgent();
            });

            const { code, data, msg } = await getCommonInfo();

            if (code === 0) {
                this.$store.dispatch('common/setData', data);
            } else {
                console.log(msg);
            }
        }

        private jump(url: any= '/') {
            this.cur = url;

            this.$router.push({
                path: `${url}` 
            });

            if (this.$route.path === url) {
                scrollToTop();
            }
        }

        private loginTeacherWeb() {
            window.open('https://teacher.knowbox.cn');
        }

        private mounted() {
            const path = location.pathname;
            
            this.cur = path;

            EventBus.$on('router.change', (cur: any) => {
                this.cur = cur;
            });
        }
	}
